<template>

  <div
    class="candidate-activities"
    :class="{ 'candidate-activities-fill': fillTab }">

    <CandidatePlacements class="mb-3" />

    <div class="btn-group d-flex group-actions mb-3">
      <button
        type="button"
        class="btn btn-dark"
        :class="{active: tab === 'timeline'}"
        @click="setTab('timeline')">
        <i class="fas fa-stream" />
      </button>
      <button
        v-if="resourceAvailability.features.includes('conversation')"
        type="button"
        class="btn btn-dark"
        :class="{active: tab === 'messaging'}"
        @click="setTab('messaging')">
        <i class="fas fa-comments" />
      </button>
      <button
        type="button"
        class="btn btn-dark"
        :class="{active: tab === 'note'}"
        @click="setTab('note')">
        <i class="fas fa-comment-alt" />
        <span class="hide-less-sm">{{ $t('Notes') }}</span>
      </button>
      <button
        type="button"
        class="btn btn-dark"
        :class="{active: tab === 'email'}"
        @click="setTab('email')">
        <i class="fas fa-envelope" />
        <span class="hide-less-sm">{{ $t('Messages') }}</span>
      </button>
      <button
        type="button"
        class="btn btn-dark"
        :class="{active: tab === 'event'}"
        @click="setTab('event')">
        <i class="far fa-calendar-alt" />
        <span class="hide-less-sm">{{ $t('Schedules') }}</span>
      </button>
      <button
        type="button"
        class="btn btn-dark"
        :class="{active: tab === 'Evaluation'}"
        @click="setTab('evaluation')">
        <i class="fas fa-thumbs-up" />
        <span class="hide-less-sm">{{ $t('Evaluations') }}</span>
      </button>
      <button
        type="button"
        class="btn btn-dark dropdown-toggle dropdown-toggle-split"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        {{ $t('More') }} <span class="sr-only">Toggle Dropdown</span>
      </button>
      <div class="dropdown-menu">
        <button
          type="button"
          class="dropdown-item"
          :class="{active: tab === 'task'}"
          @click="setTab('task')">
          <i class="far fa-check-square" /> {{ $t('Tasks') }}
        </button>
        <button
          type="button"
          class="dropdown-item"
          :class="{active: tab === 'intervideo'}"
          @click="setTab('intervideo')">
          <i class="fas fa-video" /> {{ $t('Videos') }}
        </button>
        <button
          type="button"
          class="dropdown-item"
          :class="{active: tab === 'intervoice'}"
          @click="setTab('intervoice')">
          <i class="fas fa-microphone" /> {{ $t('Voice Interviews') }}
        </button>
        <button
          type="button"
          class="dropdown-item"
          :class="{active: tab === 'quiz'}"
          @click="setTab('quiz')">
          <i class="fas fa-clipboard" /> {{ $t('Questionnaires') }}
        </button>
        <button
          type="button"
          class="dropdown-item"
          :class="{active: tab === 'share'}"
          @click="setTab('share')">
          <i class="fas fa-share" /> {{ $t('Shares') }}
        </button>
        <button
          type="button"
          class="dropdown-item"
          :class="{active: tab === 'attach'}"
          @click="setTab('attach')">
          <i class="fas fa-paperclip" /> {{ $t('Files') }}
        </button>
        <button
          type="button"
          class="dropdown-item"
          :class="{active: tab === 'export'}"
          @click="setTab('export')">
          <i class="fas fa-download" /> {{ $t('Export') }}
        </button>
        <!--<button
          type="button"
          class="dropdown-item" @click="deleteCandidate(candidate._id)">
          {{ $t('Delete candidate') }}
        </button>-->
      </div>
    </div>

    <div :class="fillTab ? 'candidate-activities-tab-fill' : 'candidate-activities-tab'">
      <div v-if="tab === 'timeline'">
        <candidate-timeline>
           </candidate-timeline>
      </div>
      <div v-if="tab === 'messaging'">
        <candidate-messaging>
          </candidate-messaging>
      </div>
      <div v-if="tab === 'intervideo'">
         <candidate-intervideo>
          </candidate-intervideo>
      </div>
      <div v-if="tab === 'intervoice'">
         <candidate-intervoice>
          </candidate-intervoice>
      </div>
      <div v-if="tab === 'quiz'">
         <candidate-questionnaire>
          </candidate-questionnaire>
      </div>
      <div v-if="tab === 'email'">
         <candidate-email>
          </candidate-email>
      </div>
      <div v-if="tab === 'attach'">
         <candidate-attach>
          </candidate-attach>
      </div>
      <div v-if="tab === 'task'">
        <candidate-task>
           </candidate-task>
      </div>
      <div v-if="tab === 'share'">
         <candidate-share>
          </candidate-share>
      </div>
      <div v-if="tab === 'evaluation'">
         <candidate-evaluation>
          </candidate-evaluation>
      </div>
      <div v-if="tab === 'note'">
         <candidate-note>
           </candidate-note>
      </div>
      <div v-if="tab === 'event'">
         <candidate-event>
          </candidate-event>
      </div>
      <div v-if="tab === 'export'">
         <candidate-export>
          </candidate-export>
      </div>
    </div>

  </div>

</template>

<script>
import CandidateTimeline from './Timeline/CandidateTimeline'
import CandidateNote from './Note/CandidateNote'
import CandidateEmail from './Email/CandidateEmail'
import CandidateEvent from './Event/CandidateEvent'
import CandidateEvaluation from './Evaluation/CandidateEvaluation'
import CandidateTask from './Task/CandidateTask'
import CandidateIntervideo from './Intervideo/CandidateIntervideo'
import CandidateIntervoice from './Intervoice/CandidateIntervoice'
import CandidateQuestionnaire from './Questionnaire/CandidateQuestionnaire'
import CandidateShare from './Share/CandidateShare'
import CandidateAttach from './Attach/CandidateAttach'
import CandidateExport from './Export/CandidateExport'
import CandidatePlacements from './Placements/CandidatePlacements'
import CandidateMessaging from './Messaging/CandidateMessaging'

export default {
  name: 'Candidate',
  components: {
    CandidateTimeline,
    CandidateNote,
    CandidateEmail,
    CandidateEvent,
    CandidateEvaluation,
    CandidateTask,
    CandidateIntervideo,
    CandidateIntervoice,
    CandidateQuestionnaire,
    CandidateShare,
    CandidateAttach,
    CandidateExport,
    CandidatePlacements,
    CandidateMessaging
  },
  props: [
  ],
  data () {
    return {
    }
  },
  computed: {
    tab () {
      return this.$route.query.candidate_tab || 'timeline'
    },
    /*
    fillTab
    the tabs that fit the column instead of growing it: the scroll lives inside
    them, not in the activities column. every other tab keeps the page scroll
    */
    fillTab () {
      return this.tab === 'messaging'
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    }
  },
  methods: {
    /*
    deleteCandidate

    deleteCandidate (id) {
      const deleteAction = () => {
        this.$store
        .dispatch('deleteCandidate', id)
        .then((result) => {
          this.$emit('deleted')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    },
    */
    setTab (tab) {
      this.$changeUrlParam({
        candidate_tab: tab
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.group-actions {
  position: sticky;
  top: -1em;
  z-index: 5;
}

/* the column grows with the tab and the scroll stays in the parent */
.candidate-activities {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

/* a fill tab needs a definite height to size against, so the column is clamped
   to the parent instead of growing past it */
.candidate-activities-fill {
  height: 100%;
}

.candidate-activities-tab {
  flex: 1;
  min-height: 0;
}

/* the flex chain only reaches the tab in fill mode: the wrapper div of the
   active tab is what stretches to the whole leftover height */
.candidate-activities-tab-fill {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.candidate-activities-tab-fill > div {
  flex: 1;
  min-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Candidate/CandidateActivities.vue